import { Button, Radio, Stack } from '@mantine/core';
import { useEffect, useState } from 'react';
import { BaseModal } from '@web/common-ui';
import { BMSSampleDecision } from '@web/common';

enum BMSRadioValue {
  hasBrought = 'hasBrought',
  bringtSpaeter = 'bringtSpaeter',
  bringtNicht = 'bringtNicht',
}

const toDecision = (value: BMSRadioValue): BMSSampleDecision => {
  if (value === BMSRadioValue.hasBrought) return BMSSampleDecision.BROUGHT;
  if (value === BMSRadioValue.bringtNicht)
    return BMSSampleDecision.NOT_BRINGING;
  return BMSSampleDecision.BRING_LATER;
};

type Props = {
  opened: boolean;
  onClose: () => void;
  onSave: (decision: BMSSampleDecision) => void;
};

export const BMSSampleModal = ({ opened, onClose, onSave }: Props) => {
  const [pendingValue, setPendingValue] = useState<BMSRadioValue | undefined>(
    undefined,
  );

  useEffect(() => {
    if (!opened) setPendingValue(undefined);
  }, [opened]);

  const handleSave = () => {
    if (!pendingValue) return;
    onSave(toDecision(pendingValue));
  };

  return (
    <BaseModal
      opened={opened}
      onClose={onClose}
      title="Wurde BMS mitgebracht?"
      description="Falls BMS heute mitgebracht wurde, wird der Link zum Fragebogen nach dem Speichern angezeigt."
      withCloseButton
      buttons={[
        <Button key="save" disabled={!pendingValue} onClick={handleSave}>
          Speichern
        </Button>,
        <Button key="cancel" variant="subtle" onClick={onClose}>
          Abbrechen
        </Button>,
      ]}
    >
      <Radio.Group
        onChange={(v) => setPendingValue(v as BMSRadioValue)}
        value={pendingValue}
      >
        <Stack>
          <Radio value={BMSRadioValue.hasBrought} label="Hat BMS mitgebracht" />
          <Radio
            value={BMSRadioValue.bringtSpaeter}
            label="Bringt BMS später mit"
          />
          <Radio value={BMSRadioValue.bringtNicht} label="Bringt BMS nicht" />
        </Stack>
      </Radio.Group>
    </BaseModal>
  );
};
